import { z } from 'zod'
import { StoreUpdateServicesRequestSchema } from '~/services/api/generated'
import { Normalization } from '~/utils/normalization'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

interface StoreUpdateServicesContext {
  readonly current_delivery_available: boolean
  readonly current_delivery_radius: number | null
}

// UpdateStoreServicesRequest::prepareForValidation
const normalize = fieldNormalizer({ blankToNull: ['pickup_instructions'] })

const schema = StoreUpdateServicesRequestSchema.strict()

export const StoreUpdateServices = (
  context: StoreUpdateServicesContext
): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(normalize, schema).superRefine((value, issues) => {
    // UpdateStoreServicesRequest::withValidator: a delivery radius is required while delivery is enabled
    const deliveryAvailable =
      'delivery_available' in value
        ? Normalization.boolValue(value.delivery_available)
        : context.current_delivery_available
    const deliveryRadius =
      'delivery_radius' in value
        ? Normalization.floatValue(value.delivery_radius, null)
        : context.current_delivery_radius

    if (deliveryAvailable && (deliveryRadius === null || deliveryRadius < 1)) {
      issues.addIssue({
        code: 'custom',
        message: 'delivery_radius_required',
        path: ['delivery_radius']
      })
    }
  })
